import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import {
    Typography,
} from '@material-ui/core';

const styles = theme => ({
    root: {
    },
    matrix: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),

        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
        },
    },
    item: {
        flex: '1 1 20%',
        margin: theme.spacing(1),
        borderRadius: theme.spacing(1),
        background: theme.colors.green3,
        '&:nth-child(even)': {
            background: theme.palette.common.white,
        },
        padding: theme.spacing(2, 2, 4, 2),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    itemTopLine: {
        textTransform: 'uppercase',
        fontWeight: 500,
    },
    price: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.5rem',
        fontWeight: 500,
        marginTop: theme.spacing(4),
    },
    priceStart: {
        fontSize: '1.5em',
        fontWeight: 600,
        marginRight: theme.spacing(0.5),
    },
    number: {
        fontSize: '2em',
        fontWeight: 600,
        marginRight: theme.spacing(1),
        color: theme.colors.green1,
    },
    priceEnd: {
        alignSelf: 'flex-end',
    },
    subline: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
    },
    license: {
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        },
    },
    licenseLink: {
        justifySelf: 'flex-end',
    },
    flex: {
        flex: '1 1 auto',
    },
    underline: {
        borderBottom: '1px solid',
    },
});

const PriceItem = ({
    classes, translate, users, price, privateUser, name,
}) => (
    <div className={classes.item}>
        <Typography color="primary" align="center" className={classes.itemTopLine}>
            {name}
        </Typography>
        <Typography color="inherit" className={classes.price}>
            <span className={classes.priceStart}>kr</span>
            <span className={classes.number}>{price}</span>
            <span className={classes.priceEnd}>/mnd</span>
        </Typography>
        <Typography className={classes.subline}>
            {privateUser ? translate('priceMatrix.privateUser') : users === 1 ? translate('priceMatrix.limitOneStudent') : translate('priceMatrix.limitStudents', { users }) }
        </Typography>
        <Typography className={classes.subline}>
            {!privateUser && translate('priceMatrix.minMonthInvoice', { months: users > 1 ? 6 : 12 }) }
        </Typography>
    </div>
);

PriceItem.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    users: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    privateUser: PropTypes.bool,
};

PriceItem.defaultProps = {
    privateUser: false,
};

const PriceMatrix = ({
    className, classes, translate,
}) => (
    <div className={className}>
        <Typography variant="h6" color="secondary" gutterBottom>
            {translate('priceMatrix.price')}
        </Typography>
        <div className={classes.matrix}>
            <PriceItem classes={classes} translate={translate} name="Privat" users={1} privateUser price={99} />
            <PriceItem classes={classes} translate={translate} name="X liten skole" users={1} price={169} />
            <PriceItem classes={classes} translate={translate} name="Liten skole" users={5} price={329} />
            <PriceItem classes={classes} translate={translate} name="Mellomstor skole" users={10} price={449} />
            <PriceItem classes={classes} translate={translate} name="Stor skole" users={20} price={729} />
        </div>
    </div>
);

PriceMatrix.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

PriceMatrix.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});


export default connect(mapStateToProps)(withStyles(styles)(PriceMatrix));
